import React, { ReactNode } from 'react';
import { Box } from '@leagueplatform/genesis-commons';
import { useIntl } from '@leagueplatform/locales';
import {
  PillTabs,
  PillTabList,
  PillTab,
} from '@leagueplatform/web-common-components';
import {
  LEADERBOARD_VIEWS,
  LeaderboardView,
} from '../hooks/use-get-leaderboard-data.hook';

interface GlobalLeaderboardToggleProps {
  teamsEnabled: boolean;
  onLeaderboardViewChange: (view: LeaderboardView) => void;
  isLoadingOrError: boolean;
  children: ReactNode;
}

interface TogglePodiumContainerProps {
  teamsEnabled: boolean;
  isLoadingOrError: boolean;
  children: ReactNode;
}

const TogglePodiumContainer = ({
  teamsEnabled,
  isLoadingOrError,
  children,
}: TogglePodiumContainerProps) => {
  if (teamsEnabled || !isLoadingOrError) {
    return (
      <Box
        backgroundColor="surface.background.secondary"
        borderColor="onSurface.border.subdued"
        borderRadius="small"
        borderWidth="thin"
        marginBottom="two"
        padding={{ _: 'one', tablet: 'two' }}
        textAlign="center"
      >
        {children}
      </Box>
    );
  }
  return <Box>{children}</Box>;
};

export const GlobalLeaderboardToggle = ({
  teamsEnabled,
  onLeaderboardViewChange,
  isLoadingOrError,
  children,
}: GlobalLeaderboardToggleProps) => {
  const { formatMessage } = useIntl();

  return (
    <TogglePodiumContainer
      teamsEnabled={teamsEnabled}
      isLoadingOrError={isLoadingOrError}
    >
      <PillTabs
        defaultValue={LEADERBOARD_VIEWS[0]}
        onValueChange={(value) => {
          onLeaderboardViewChange(value as LeaderboardView);
        }}
      >
        {teamsEnabled && (
          <Box width="fit-content" marginX="auto" marginBottom="two">
            <PillTabList>
              <PillTab value={LEADERBOARD_VIEWS[0]}>
                {formatMessage({ id: 'INDIVIDUAL_CAP' })}
              </PillTab>
              <PillTab value={LEADERBOARD_VIEWS[1]}>
                {formatMessage({ id: 'TEAMS' })}
              </PillTab>
            </PillTabList>
          </Box>
        )}
        {children}
      </PillTabs>
    </TogglePodiumContainer>
  );
};
